import { skipToken } from '@reduxjs/toolkit/query';
import { useEffect } from 'react';

import { useGetRecordTechnologicalMapQuery } from '@app/api/TechnologicalMaps';
import { selectRecordModal } from '@app/components/RecordModal/model/selectors';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';
import { useAppSelector } from '@app/store';

export const useFinalTechMapTableEffect = () => {
  const { activeBranchId: ActiveBranchId } = useUserPrint();
  const { showNotification } = useNotification();
  const { record } = useAppSelector(selectRecordModal);

  const recordId = record?.Id;

  const queryArgs =
    recordId != null && ActiveBranchId != null
      ? { ActiveBranchId, recordId }
      : skipToken;

  const {
    data: recordTechnologicalMapData,
    error: recordTechnologicalMapError,
    isLoading: isRecordTechnologicalMapLoading,
    refetch: refetchRecordTechnologicalMap,
  } = useGetRecordTechnologicalMapQuery(queryArgs, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (recordTechnologicalMapError) {
      showNotification(handleCatchError(recordTechnologicalMapError));
    }
  }, [recordTechnologicalMapError, showNotification]);

  return {
    recordTechnologicalMapData,
    isRecordTechnologicalMapLoading,
    refetchRecordTechnologicalMap,
  };
};
